/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Close_ActionInputs */

const en_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close onboarding`)
};

const de_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding schließen`)
};

const pt_br2_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar introdução`)
};

const tr_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıcı kapat`)
};

const zh_cn2_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭新手引导`)
};

const zh_hk2_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉新手引導`)
};

const ko_kr2_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온보딩 닫기`)
};

const ru_ru2_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть онбординг`)
};

const es_419_onboarding_v1_close_action = /** @type {(inputs: Onboarding_V1_Close_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar introducción`)
};

/**
* | output |
* | --- |
* | "Close onboarding" |
*
* @param {Onboarding_V1_Close_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_close_action = /** @type {((inputs?: Onboarding_V1_Close_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Close_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_close_action(inputs)
	if (locale === "de") return de_onboarding_v1_close_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_close_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_close_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_close_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_close_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_close_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_close_action(inputs)
	return es_419_onboarding_v1_close_action(inputs)
});